/**
 * 局部收折的行为方式
 *
 * @public
 */
var ShrinkType;
(function (ShrinkType) {
    /** 组内局部按钮就地收折到所在顺序位置 */
    ShrinkType[ShrinkType["ON_THE_SPOT"] = 0] = "ON_THE_SPOT";
    /** 组内局部按钮收折到组内末尾位置 */
    ShrinkType[ShrinkType["GROUP_TAIL"] = 1] = "GROUP_TAIL";
})(ShrinkType || (ShrinkType = {}));

export { ShrinkType };
//# sourceMappingURL=toolbar-schema.interface.js.map
